/**
 * @description
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IOutputBase } from './base';

interface IInput {
    key: string;
}

export const getConfig = (data: IInput): Promise<IOutputBase<string>> => {
    return fetchData(Api.NAPI_GET_CONFIG, data).then(( res: any ) => {
        return res;
    });
};
